import { InfiniteScrollLoading } from 'components/InfiniteScrollLoading';
import { AvailabilityEmptyState } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/AvaibilityEmptyState';
import { AvailabilityAvatar } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/AvailabilityAvatar';
import { AvailableMembersDataContext } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/AvailableMemeberTab.context';
import {
  JaneFacility,
  JaneName,
  JaneWrapper,
  TableAvailabilityRow,
  TableAvailabilityRowWrapper,
  TableColumn,
  TeamMemberWrapper,
  TimeColumn,
} from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/index.styled';
import { DateTime } from 'luxon';
import { isCurrentLanguageFrench } from 'providers/i18NextProvider.constants';
import { FC, Fragment, useContext } from 'react';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';
import { OrderAvailability } from 'types/graphql';
import { getLocalizedDateFormat } from 'utils/getLocalizedDateFormat';
import { useSelector } from 'react-redux';

const AvailabilityRow: FC<OrderAvailability & { timeZone: string }> = (props): JSX.Element => {
  const { createdAt, jane, timeZone } = props;
  const is24hTimeFormat = useSelector(isUserTimeFormat24hSelector);
  const { month } = getLocalizedDateFormat(createdAt, timeZone);

  const isToday = DateTime.fromISO(createdAt)
    .setZone(timeZone)
    .hasSame(DateTime.now().setZone(timeZone), 'day');

  const hoursMinutes = isCurrentLanguageFrench() || is24hTimeFormat ? 'HH:mm' : 'h:mm a';
  const at = isCurrentLanguageFrench() ? 'à' : 'at';

  const translatedDate = isToday
    ? DateTime.fromISO(createdAt).setZone(timeZone).toFormat(hoursMinutes)
    : `${month} ${DateTime.fromISO(createdAt)
        .setZone(timeZone)
        .toFormat(`dd, yyyy '${at}' ${hoursMinutes}`)}`;

  return (
    <TableAvailabilityRowWrapper>
      <TableAvailabilityRow>
        <TableColumn>
          <TimeColumn>{translatedDate}</TimeColumn>
        </TableColumn>
        <TableColumn>
          <TeamMemberWrapper>
            <div>
              <AvailabilityAvatar {...jane} />
            </div>
            <JaneWrapper>
              <JaneName>{jane?.shorthandName}</JaneName>
              <JaneFacility>{jane?.communityName}</JaneFacility>
            </JaneWrapper>
          </TeamMemberWrapper>
        </TableColumn>
      </TableAvailabilityRow>
    </TableAvailabilityRowWrapper>
  );
};

export const AvailableMemberTabTableBody = () => {
  const { data, loadMore } = useContext(AvailableMembersDataContext);
  const order = data?.order;

  if (!data) return null;
  if (!order) return null;
  if (!order?.orderAvailabilities) return null;
  if (!order?.orderAvailabilities?.nodes) return null;
  if (order?.orderAvailabilities?.nodes?.length === 0) return <AvailabilityEmptyState />;
  return (
    <Fragment>
      {order.orderAvailabilities.nodes.map((node: OrderAvailability) => (
        <AvailabilityRow {...node} key={node.id} timeZone={order?.timeZone?.toString()} />
      ))}
      {!!order.orderAvailabilities.pageInfo.hasNextPage ? (
        <InfiniteScrollLoading onViewportEnter={loadMore} />
      ) : null}
    </Fragment>
  );
};
